import { EngravingInputControl } from './EngravingInputControl';
import { WebsitePlugin } from '@gift/types/WebsitePlugin';
import { engravingToFfCanvas} from '@gift/engraving-core/engravingToFfCanvas';
import { EngravingVariableOptions } from '@gift/engraving-core/EngravingVariableOptions';
import { EngravingVariableInput } from '@gift/engraving-core/EngravingVariableInput';

export const engravingWebsitePlugin: WebsitePlugin.Variable<EngravingVariableOptions, EngravingVariableInput> = {
    pluginId: 'engraving',
    InputControl: EngravingInputControl,
    toFfCanvas: engravingToFfCanvas
};